import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade border border-top-0",
  id: "panel-pre-domestic-oral",
  role: "tabpanel",
  "aria-labelledby": "tab-pre-domestic-oral"
}
const _hoisted_2 = { class: "container p-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mark" }, "ハイライト表示"),
  /*#__PURE__*/_createTextVNode("されたものは招待講演です。")
], -1)
const _hoisted_4 = { class: "list-group" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentations, (presentation, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "list-group-item"
          }, [
            _createElementVNode("h5", {
              class: _normalizeClass(presentation.invited ? 'mb-1 mark' : 'mb-1'),
              innerHTML: `[${_ctx.presentations.length - index}] ${presentation.title}`
            }, null, 10, _hoisted_5),
            _createElementVNode("p", {
              class: "mb-0",
              innerHTML: presentation.author
            }, null, 8, _hoisted_6),
            _createElementVNode("p", {
              class: "mb-0",
              innerHTML: presentation.conference
            }, null, 8, _hoisted_7),
            _createElementVNode("p", _hoisted_8, "@ " + _toDisplayString(presentation.location), 1),
            _createElementVNode("p", _hoisted_9, [
              (presentation.hasOwnProperty('number'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(presentation.number) + "、", 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(presentation.date), 1)
            ]),
            (presentation.hasOwnProperty('note'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "mb-0",
                  innerHTML: presentation.note
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}